import '../assets/css/Footer.css'
import '../assets/css/Common.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram, faYoutube, faXTwitter } from "@fortawesome/free-brands-svg-icons"
import { Link } from 'react-router-dom'

function Footer() {

    return(
        <footer className="flex-container full-width main-color-background text-white footer flex-column">
            <div className="flex-container full-width space-around top-margin-2 footer-columns-container">
                <div className='flex-container flex-column width-30p footer-column'>
                    <p className='footer-title'>Korisni linkovi</p>
                    <ul>
                        <li>
                            <Link to={"korisni-linkovi/svijet"}>Svijet</Link>
                        </li>
                        <li>
                            <Link to={"korisni-linkovi/jugoistocna-evropa"}>Jugoistočna Evropa</Link>
                        </li>
                        <li>
                            <Link to={"korisni-linkovi/bosna-i-hercegovina"}>Bosna i Hercegovina</Link>
                        </li>
                    </ul>
                </div>

                <div className='flex-container flex-column width-30p footer-column'>
                    <p className='footer-title'>O portalu</p>
                    <ul>
                        <li><Link to={"onama"}>O nama</Link></li>
                        <li><Link to={"impressum"}>Impressum</Link></li>
                        <li><Link to={"kontakt"}>Kontakt</Link></li>
                        <li><Link to={"saradnja"}>Saradnja</Link></li>
                        <li><Link to={"kriteriji-za-recenzije-i-radove"}>Kriteriji za recenzije i radove</Link></li>
                    </ul>
                </div>

                <div className='flex-container flex-column width-30p footer-column'>
                    <p className='footer-title'>Uvjeti korištenja</p>
                    <p>Dopušteno je preuzimati tekstove sa portala, uz obavezno navođenje izvora i upućivanje na link sa kojeg se informacija preuzima.</p>
                    <ul>
                        <li>
                            <Link to={"politika-privatnosti"}>Politika privatnosti</Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="flex-container full-width center-justify">
                <a target="_blank" rel='noreferrer' href="https://www.facebook.com/people/Historiografijaba/100063093926465/" className='icon-link text-white right-margin-2p'>
                    <FontAwesomeIcon icon={faFacebook}></FontAwesomeIcon>
                </a>
                <a target="_blank" rel='noreferrer' href="https://www.instagram.com/historiografijaba/"  className='icon-link text-white right-margin-2p'>
                    <FontAwesomeIcon icon={faInstagram}></FontAwesomeIcon>
                </a>
                <a target="_blank" rel='noreferrer' href="https://x.com/Historiografiba"  className='icon-link text-white right-margin-2p'>
                    <FontAwesomeIcon icon={faXTwitter}></FontAwesomeIcon>
                </a>
                <a target="_blank" rel='noreferrer' href="https://www.youtube.com/channel/UCD2_Gqs9ylnjF7tRnU6qQjA/videos?view_as=subscriber"  className='icon-link text-white'>
                    <FontAwesomeIcon icon={faYoutube}></FontAwesomeIcon>
                </a>
            </div>

            <div className="flex-container full-width center-justify bottom-margin-2p">
                <p className="copyright">historiografija.ba © 2026</p>
            </div>
        </footer>
    )
}

export default Footer